<template>
  <!-- <div class="bg-container page">
    <img class="bg-img" src="img/login/login-bg.png" />
    <div class="bg-wrapper">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()" />
          </template>
<template #right>
            <div class="language" @click="$router.push('/language')">
              <img :src="require('../images/language/' + lang + '.png')" />
            </div>
          </template>
</van-nav-bar>
<div class="wrapper">
  <div class="logo-container">
    <div class="logo-wrapper">
      <img class="logo-img" :src="
                  this.$store.getters.getBaseInfo.ico !== undefined
                    ? this.$store.getters.getBaseInfo.ico
                    : '/img/null.png'
                " />
    </div>
  </div>
  <div class="title">{{ $t("auth.login") }}</div>
  <div class="loginForm">
    <van-field v-model="username" clearable input-align="center" class="input"
      :placeholder="$t('auth.username_place')" />
    <van-field v-model="password" :type="passwordType" input-align="center" class="input"
      :placeholder="$t('auth.pwd_place')">
      <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
    </van-field>
    <div class="reset-text">
      <span>{{$t("auth.forgetpwd")}}?</span>
    </div>
    <div @click="toRegister()" class="register-text">
      <span>{{$t("auth.no_account")}}</span>
    </div>
    <div class="register-text" @click="toServicePage()">
      <div class="register-text" style="color: white;">
        {{$t("my.contactzx")}}
      </div>
    </div>
    <van-button class="login-btn" type="primary" size="normal" @click="doLogin()">{{$t("auth.login")}}</van-button>
  </div>
</div>
</div>
</div>
</div> -->

  <div class="user-container">
    <div class="header-logo">
      <img src="@/assets/login.jpg" alt="">
    </div>

    <form @submit.prevent="register">
      <div class="form-group">
        <input type="text" v-model="username" required :placeholder="$t('auth.username_place')">
      </div>

      <div class="form-group">
        <input type="password" v-model="password" required :placeholder="$t('auth.pwd_place')">
      </div>

      <button type="submit">{{$t("auth.login")}}</button>

      <div class="or">
        <div class="xian"></div>
        <div class="or-text"></div>
        <div class="xian"></div>
      </div>

      <div class="or other-login" @click="toRegister">
        <span>{{$t("auth.no_account")}}</span>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: this.$i18n.locale || "vi_vi",
      password: this.inputValue,
      passwordType: "password",
    };
  },

  mounted() {
    localStorage.setItem("lang", 'vi_vi');
    // this.lang = localStorage.getItem("lang") || 'vi_vi';
  },
  methods: {
    register() {
      try {
        this.doLogin()
      } catch (error) {
        console.error('登入失败:', error);
        alert('登入失败，请重试。');
      }
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toServicePage() {
      const service = this.$store.getters.getBaseInfo;
      console.log(service)
      if (service.iskefu == 1) {
        console.log('ssss')
        window.location.href = service.kefu
      }
      // this.$router.push("ServicePage");
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
          // this.$router.push({path:'/'});
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },

  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import "~@/common/index.less";
@import "~@/common/user.less";
</style>
